export const aboutData = {
    title: 'Who I am',
    description1: "I'm Mavin Sandeep, a product-focused developer from Tiruchirappalli building systems where hardware and software work as one.",
    description2: "My core focus is Embedded Systems, IoT, and Full Stack development using ESP8266/ESP32, custom firmware, PCB design in KiCad, cloud APIs, and practical AI/ML. I design for real deployment: resilient, scalable, and user-friendly.",
}
